var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "case-page" },
    [
      _c("c-header-return", {
        attrs: { title: _vm.case_header_title, isBtnShow: true },
      }),
      _c(
        "div",
        { staticClass: "case-open" },
        [
          _vm.case_awards.length && _vm.case_open_number <= 1
            ? _c(
                "p-case-opening",
                {
                  ref: "case_opening_box",
                  attrs: {
                    items: _vm.case_awards,
                    isTransition: !_vm.is_jump_case_open_animation,
                  },
                  on: {
                    on_finished: function () {
                      return _vm.on_case_opened()
                    },
                  },
                },
                [
                  !_vm.isRunning
                    ? _c("div", { staticClass: "case-con" }, [
                        _c("div", { staticClass: "case-img-con" }, [
                          _vm.case_info.casePic
                            ? _c("div", { staticClass: "case-img" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm._f("imgfilter")(
                                      _vm.case_info.casePic
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm.case_info.itemPic
                            ? _c("div", { staticClass: "case-img" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm._f("imgfilter")(
                                      _vm.case_info.itemPic
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.case_awards.length && _vm.case_open_number > 1
            ? _c(
                "p-case-opening-more",
                {
                  ref: "case_opening_box_more",
                  attrs: {
                    items: _vm.case_awards,
                    lotteryCount: _vm.case_open_number,
                    isTransition: !_vm.is_jump_case_open_animation,
                  },
                  on: {
                    on_finished: function () {
                      return _vm.on_case_opened()
                    },
                  },
                },
                [
                  !_vm.isRunning
                    ? _c("div", { staticClass: "case-con" }, [
                        _c("div", { staticClass: "case-img-con" }, [
                          _vm.case_info.casePic
                            ? _c("div", { staticClass: "case-img" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm._f("imgfilter")(
                                      _vm.case_info.casePic
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm.case_info.itemPic
                            ? _c("div", { staticClass: "case-img" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm._f("imgfilter")(
                                      _vm.case_info.itemPic
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "ctrl-con flex-col" }, [
            _c("div", { staticClass: "ctrl-con-top flex flex-center-1" }, [
              _c("div", { staticClass: "open-case-left" }, [
                _vm.mpcCaseSettings.isMPCaseEnabled &&
                _vm.$canShowFeature("multiple_people_case") &&
                (_vm.case_info.useType == 0 || _vm.case_info.useType == 88)
                  ? _c(
                      "button",
                      {
                        staticClass: "open-case-btn",
                        staticStyle: { width: "100px" },
                        on: { click: _vm.onGoToMPCList },
                      },
                      [_vm._v(" 合开 ")]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "open-case-btn-con" }, [
                _vm.case_info.useType != 3
                  ? _c(
                      "button",
                      {
                        staticClass: "open-case-btn",
                        on: {
                          click: function () {
                            return _vm.case_open("normal")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " 打开 " +
                            _vm._s(_vm.case_open_number) +
                            "次 " +
                            _vm._s(_vm._f("conversion")(_vm.case_open_amount)) +
                            " "
                        ),
                        _vm.isUsingHappyCoin
                          ? _c("span", [_vm._v("欢乐豆")])
                          : _vm._e(),
                        _vm._v("  "),
                      ]
                    )
                  : _vm._e(),
                _vm.case_info.useType == 3
                  ? _c(
                      "button",
                      {
                        staticClass: "open-case-btn",
                        on: { click: _vm.toggle_case_open_cdk_modal_show },
                      },
                      [_vm._v(" 输入CD-KEY ")]
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "open-case-right" }, [
                !_vm.case_info.isTrialable
                  ? _c(
                      "button",
                      {
                        staticClass: "open-case-btn try",
                        on: {
                          click: function () {
                            return _vm.case_open_emu()
                          },
                        },
                      },
                      [_vm._v(" 试玩 ")]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "ctrl-con-bottom flex flex-center-1",
                staticStyle: { "margin-top": "40px" },
              },
              [
                _c("div", { staticClass: "open-case-left" }),
                _c(
                  "div",
                  {
                    staticClass: "open-count-con flex flex-center-1 flex-wrap",
                  },
                  [
                    _vm.case_info.useType == 0 || _vm.case_info.useType == 88
                      ? _c(
                          "div",
                          { staticClass: "open-count" },
                          _vm._l(
                            Array.from(Array(5).keys()).map(function (num) {
                              return num + 1
                            }),
                            function (number) {
                              return _c(
                                "div",
                                {
                                  key:
                                    number +
                                    "_" +
                                    (number === _vm.case_open_number),
                                  staticClass: "open-count-item",
                                  class: {
                                    active: number === _vm.case_open_number,
                                  },
                                  on: {
                                    click: function () {
                                      if (!_vm.isRunning) {
                                        _vm.case_open_number = number
                                      }
                                    },
                                  },
                                },
                                [_vm._v(" x" + _vm._s(number) + " ")]
                              )
                            }
                          ),
                          0
                        )
                      : _c("div", { staticClass: "open-count" }, [_vm._m(0)]),
                  ]
                ),
                _c("div", { staticClass: "rightItem open-case-right" }, [
                  _c("div", { staticClass: "jump-animate-con" }, [
                    _c(
                      "div",
                      { staticClass: "jump-animate" },
                      [
                        _c("i-switch", {
                          attrs: {
                            "false-color": "#14131d",
                            "true-color": "#F5B844",
                          },
                          on: {
                            "on-change": _vm.toggle_is_jump_case_open_animation,
                          },
                          model: {
                            value: _vm.is_jump_case_open_animation,
                            callback: function ($$v) {
                              _vm.is_jump_case_open_animation = $$v
                            },
                            expression: "is_jump_case_open_animation",
                          },
                        }),
                        _c("span", { staticClass: "text" }, [_vm._v("动画")]),
                      ],
                      1
                    ),
                  ]),
                  _vm.case_info.isEnableAccumulateCase
                    ? _c(
                        "div",
                        {
                          staticClass: "case-gameInstanceBoxItem",
                          on: { click: _vm.onGameInstanceBox },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "case-gameInstanceBox",
                              class: _vm.gameInstance_info.isGameInstanceOpen
                                ? "con-gameInstanceBox-active"
                                : "",
                            },
                            [
                              _c(
                                "el-image",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "con-gameInstanceBox-casePic",
                                      class: _vm.gameInstance_info
                                        .isGameInstanceOpen
                                        ? "con-gameInstanceBox-casePic-open"
                                        : "",
                                      attrs: {
                                        src: _vm._f("imgfilter")(
                                          _vm.gameInstance_info.casePic
                                        ),
                                        fit: "cover",
                                      },
                                    },
                                    "el-image",
                                    _vm.$attrs,
                                    false
                                  ),
                                  _vm.$listeners
                                )
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "con-gameInstanceBox-title flex flex-center-1",
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.gameInstance_info.caseName)
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "con-gameInstanceBox-btn flex flex-center-1",
                                },
                                [
                                  _vm.gameInstance_info.isGameInstanceOpen
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "open-case-btn flex flex-center-1",
                                        },
                                        [_vm._v(" 打开 ")]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass:
                                            "open-case-btn-1 flex flex-center-1",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.case_info
                                                  .accumulateCaseRoundCount
                                              ) +
                                              "/" +
                                              _vm._s(
                                                _vm.case_info.accumulateCaseRate
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm.case_info.isShowHistory
        ? _c("div", { staticClass: "recent-drop-con" }, [
            _c("h2", { staticClass: "title" }, [_vm._v("最近掉落")]),
            _c(
              "div",
              { staticClass: "recent-drop" },
              _vm._l(_vm.drop_awards, function (item, award_index) {
                return _c(
                  "div",
                  { key: award_index, staticClass: "item" },
                  [
                    _c("c-award", {
                      staticClass: "award",
                      attrs: {
                        rarity: item.rarity,
                        picture: item.itempic,
                        name: item.itemname,
                        price: item.price,
                        width: "100%",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "case-award" }, [
        _c("div", { staticClass: "case-award-title" }, [
          _c("div", { staticClass: "text" }, [_vm._v("此箱子包含以下物品")]),
          _c("div", { staticClass: "probability" }, [
            _c(
              "div",
              {
                staticClass: "ruler-text",
                on: {
                  click: function ($event) {
                    _vm.notice_modal_show = true
                  },
                },
              },
              [
                _c("span", [_vm._v("概率说明")]),
                _c("img", {
                  attrs: {
                    src: require("../../assets/images/help_fill.png"),
                    alt: "",
                  },
                }),
              ]
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "case-award-list" },
          _vm._l(_vm.case_awards, function (item, award_index) {
            return _c(
              "div",
              { key: award_index, staticClass: "item" },
              [
                _c("c-award", {
                  staticClass: "award",
                  attrs: {
                    rarity: item.rarity,
                    picture: item.itempic,
                    name: item.itemname,
                    price: item.price,
                    rate: item.viewRate,
                    viewRate: item.rollRangeStr,
                    width: "100%",
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            closable: false,
            width: "'400rem'",
          },
          model: {
            value: _vm.is_case_open_cdk_modal_show,
            callback: function ($$v) {
              _vm.is_case_open_cdk_modal_show = $$v
            },
            expression: "is_case_open_cdk_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: _vm.case_info.caseName, has_close_button: "" },
              on: { close_button_click: _vm.toggle_case_open_cdk_modal_show },
            },
            [
              _c("div", { staticClass: "case-open-cdk app-form" }, [
                _c("p", { staticClass: "case-open-cdk__desc" }, [
                  _vm._v("请输入您的CD-KEY，以开启箱子"),
                ]),
                _c("label", { staticClass: "app-form__field" }, [
                  _c("div", { staticClass: "app-form__field_icon_input" }, [
                    _c("i", { staticClass: "ivu-icon ivu-icon-md-key" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.case_open_cdk,
                          expression: "case_open_cdk",
                        },
                      ],
                      staticClass: "app-form__field__input pad50",
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        placeholder: "请输入您的CD-KEY",
                      },
                      domProps: { value: _vm.case_open_cdk },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.case_open_cdk = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "submit-button",
                  staticStyle: { width: "100%" },
                  on: {
                    click: function ($event) {
                      return _vm.case_open("cdk")
                    },
                  },
                },
                [_vm._v(" 确认开箱 ")]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "开箱概率说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(" 每次开启盲盒为新的一轮"),
                  _c("span", [_vm._v("独立计算")]),
                  _vm._v(" ，多次开启盲盒并 "),
                  _c("span", [_vm._v("不意味")]),
                  _vm._v("着某区间"),
                  _c("span", [_vm._v("概率累加")]),
                  _vm._v(" 。 "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例1：")]),
                _c("p", [
                  _vm._v(" 盲盒内有A、B两件饰品,获得概率都为"),
                  _c("span", [_vm._v("50%")]),
                  _vm._v(",当连续开启该盲盒时, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("开启结果"),
                  _c("span", [_vm._v("稳定")]),
                  _vm._v("为ABABAB "),
                ]),
                _c("br"),
                _c("br"),
                _c("p", [_vm._v("举例2：")]),
                _c("p", [
                  _vm._v(" 某饰品掉率为"),
                  _c("span", [_vm._v("10%")]),
                  _vm._v(", 当连续开启该盲盒时, "),
                  _c("span", [_vm._v("可能10次无掉落")]),
                  _vm._v("该饰品, 也可能20次掉落1次, "),
                  _c("span", [_vm._v("无法保证")]),
                  _vm._v("每开10次"),
                  _c("span", [_vm._v("必定掉落")]),
                  _vm._v("1次该饰品 "),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("c-RewardModal", {
        ref: "case_reward_ui",
        attrs: {
          case_info: _vm.case_info,
          resetText: _vm.is_case_open_try ? "关闭" : "存入背包",
        },
        on: {
          "on-onjileigameInstanceRewardCloseHandle":
            _vm.ongameInstanceRewardCloseHandle,
        },
      }),
      _vm.awardAverageExtraCases.length > 0
        ? _vm._l(_vm.awardAverageExtraCases, function (averItem, averIndex) {
            return _c("c-awardAverageExtraCase-item", {
              key: averIndex,
              attrs: { average_case_info: averItem },
              on: {
                "on-ongameInstanceRewardCloseHandle":
                  _vm.ongameInstanceRewardCloseHandle,
              },
              model: {
                value: averItem.isAwardAverageExtraCaseShow,
                callback: function ($$v) {
                  _vm.$set(averItem, "isAwardAverageExtraCaseShow", $$v)
                },
                expression: "averItem.isAwardAverageExtraCaseShow",
              },
            })
          })
        : _vm._e(),
      _c("c-unpackgameInstance-item", {
        attrs: {
          type: "accumulate",
          muxiangCaseId: _vm.case_info.caseId,
          gameInstanceId: _vm.gameInstance_info.caseId,
        },
        on: { "on-unpackgameInstanceClose": _vm.onUnpackgameInstanceClose },
        model: {
          value: _vm.unpackgameInstance_item_show,
          callback: function ($$v) {
            _vm.unpackgameInstance_item_show = $$v
          },
          expression: "unpackgameInstance_item_show",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "open-count-btn" }, [
      _c("div", { staticClass: "open-count-item active" }, [_vm._v("x1")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }